import Cookies from 'universal-cookie';
import idx from 'idx';
import { buttonStateMap, validationTextMap } from './constant';

const cookies = new Cookies();

export const isDisabled = state =>
  state === buttonStateMap.DISABLED || state === buttonStateMap.LOADING || state === buttonStateMap.TOC_NOT_CHECKED;

export const escapeScriptTags = html =>
  html.replace(
    /<script(?:(?!\/\/)(?!\/\*)[^'"]|"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\/\/.*(?:\n)|\/\*(?:(?:.|\s))*?\*\/)*?<\/script>/g,
    ''
  );

// isCheck refers to "is it the check API request (not apply)"
export const getStateByResultCode = (code, isCheck) => {
  switch (+code) {
    case 0: {
      /*
       * code === 0 means "good to go" in check API
       * and it also means "applied successfully" in apply API
       */
      return isCheck ? buttonStateMap.ENABLED : buttonStateMap.SUCCESS;
    }
    case 1: {
      return buttonStateMap.ALREADY_APPLIED;
    }
    case 2: {
      return buttonStateMap.EXPIRED;
    }
    case 3:
    default: {
      return buttonStateMap.RETRY;
    }
  }
};

export const isCheckOK = res => +res.code === 200 && +idx(res, _ => _.results[0].result) === 0;

export const buttonStateFactory = res => {
  // const isCheck = idx(res, _ => _.results.length); // MEMO: this code will cause error on IE11
  const isCheck = res && res.results && res.results.length;
  const resultCode = isCheck ? res.results[0].result : res.result;

  if (+res.code !== 200) {
    return +res.code === 201 ? buttonStateMap.LOGIN : buttonStateMap.RETRY;
  }

  return getStateByResultCode(resultCode, isCheck);
};

export const validationTextFactory = res => {
  /*
   * result is an Array in check API
   * but a string in apply API
   */
  const resultCode = res.results && res.results.length ? res.results[0].result : res.result;

  if (+res.code === 200) {
    if (resultCode === 'not found campaign') {
      return validationTextMap.CAMPAIGN_NOT_FOUND;
    }

    /*
     * either the campaign has ended or the user has already applied before
     * it's meanlingless for us to display the statements or validation text anymore
     */
    switch (+resultCode) {
      case 0: // successful
      case 1: // already joined
      case 2: {
        // campaign expired
        // gonna show the feedback on the button instead of validation text
        return '';
      }
      case 3: {
        // device not allowed
        return validationTextMap.DEVICE_NOT_ALLOWED;
      }
      default:
        break;
    }
  } else {
    /*
     * we should properly tell user the reason they failed
     * with necessary information
     * and encourage them to retry
     */
    if (+res.code === 201) {
      return validationTextMap.LOGIN_ISSUE;
    } else if (+res.code === 100) {
      return validationTextMap.MAINTENANCE;
    }

    return validationTextMap.FALLBACK;
  }

  return '';
};

export const sendRAT = (cId, success, mountId) => {
  if (typeof window !== 'undefined' && window.RAT && typeof window.RAT.addCustomEvent === 'function') {
    /*
     * [NOTE]
     *
     * if you wanna send the RAT data to test center
     * please manually set the a cookie: 'is-rat-test' to 1
     */
    const isRATTest = cookies.get('is-rat-test');

    const ratConfig = {
      // accountId: '484',
      serviceId: 1,
      includeInput: true,
      options: ['url', 'ua'],
      pData: {
        compid: [mountId || 'campaign_entry'],
      },
      cpData: {
        campaign_id: cId,
      },
      eventType: 'click',
    };

    if (success) {
      ratConfig.cvData = {
        entry_complete: 1,
      };
    } else {
      ratConfig.cpData.entry_error = 1;
    }

    if (isRATTest) {
      ratConfig.accountId = '999';
    }

    RAT.addCustomEvent(ratConfig);
  }
};

export const isValidState = state =>
  Object.keys(buttonStateMap)
    .map(key => buttonStateMap[key])
    .indexOf(state) > -1;

// Redirection
export const redirectToUrl = (url, delay) =>
  new Promise(resolve => {
    setTimeout(() => {
      window.location.href = url;
      resolve();
    }, delay);
  });



// WEBPACK FOOTER //
// ./src/util.js